import useApiErrorHandler from '@/core/composable/use-api-error-handler';

const responeOnRejectedInterceptor = async (error: any) => {
    const { handleError } = useApiErrorHandler();
    return handleError(error);
}

export default responeOnRejectedInterceptor;
